<template>
  <div class="picture-list">
    <img
      v-for="(img,index) in data"
      :key="index"
      :src="img"
      class="thumbnail"
      @click="previewImage(index)"
    />
  </div>
</template>

<script>
import preview from "./preview";
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    previewImage(index) {
      preview.$emit("open-image", this.data, index);
    }
  }
};
</script>

<style lang="less" scoped>
.picture-list {
  padding-top: 15px;
  display: flex;
  flex-wrap: wrap;
}
.picture-list .thumbnail {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin: 5px 12.5px 5px 0;
  border-radius: 4px;
  cursor: zoom-in;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
}
.picture-list .thumbnail:nth-child(9n) {
  margin-right: 0;
}
</style>